import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import OtpView from "../../components/Otp/OtpView";
import MainWrapper from "../../Wrapper/MainWrapper";
import { getCookie } from "../../utils/helper";
export default function Otp() {
    const navigate = useNavigate();
    useEffect(() => {
      if (getCookie("yop-token")) {
        navigate("/");
      }
    }, [navigate]);
  return (
    <>
    <ToastContainer  style={{zIndex:'999999'}}/>
      <MainWrapper>
        <OtpView />
      </MainWrapper>
    </>
  );
}
